// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Gaegu:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Gaegu", cursive; }

:root {
  font-size: 20px; }

a {
  text-decoration: none;
  color: #0095ff; }

.text-red {
  color: red; }

.text-blue {
  color: #0095ff; }

.text-green {
  color: #00b106; }

.btn {
  border-radius: 6px;
  border: 2px solid #000;
  color: initial;
  cursor: pointer;
  display: block;
  font-size: 1rem;
  font-weight: 500;
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  text-decoration: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  font-family: inherit; }
  .btn.blue {
    border-color: rgba(0, 149, 255, 0.8); }
    .btn.blue:hover {
      background-color: rgba(0, 149, 255, 0.8);
      border-color: #0095ff; }
  .btn.green {
    border-color: rgba(0, 177, 6, 0.8); }
    .btn.green:hover {
      background-color: rgba(0, 177, 6, 0.8);
      border-color: #00b106; }
  .btn:hover {
    background-color: rgba(0, 177, 6, 0.8);
    border-color: #00b106;
    color: white; }

button.no-style,
button.link {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font-size: inherit;
  font-family: inherit;
  cursor: pointer; }

button.link {
  color: #0095ff;
  padding-left: 0.2rem; }

button.link:hover {
  text-decoration: underline; }

input {
  padding: 0.5rem 1rem;
  border: 2px dashed gainsboro;
  border-radius: 4px;
  font-size: 1rem;
  font-family: inherit; }
`, "",{"version":3,"sources":["webpack://./src/style/typograhpy.scss","webpack://./src/style/colors.scss","webpack://./src/style/buttons.scss","webpack://./src/style/forms.scss"],"names":[],"mappings":"AAEA;EACE,6BAA6B,EAAA;;AAG/B;EACE,eAAe,EAAA;;AAGjB;EACE,qBAAqB;EACrB,cCV4B,EAAA;;ADe1B;EACE,UCfqB,EAAA;;ADcvB;EACE,cChBwB,EAAA;;ADe1B;EACE,cCbuB,EAAA;;ACgB7B;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,qIAC8D;EAC9D,oBAAoB,EAAA;EAxBlB;IACE,oCDTwB,EAAA;ICWxB;MACE,wCDZsB;MCatB,qBDbsB,EAAA;ECQ1B;IACE,kCDNuB,EAAA;ICQvB;MACE,sCDTqB;MCUrB,qBDVqB,EAAA;ECgB7B;IAiBI,sCDjCyB;ICkCzB,qBDlCyB;ICmCzB,YAAY,EAAA;;AAIhB;;EAEE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe,EAAA;;AAGjB;EACE,cDtD4B;ECuD5B,oBAAoB,EAAA;;AAGtB;EACE,0BAA0B,EAAA;;AC7D5B;EACE,oBAAoB;EACpB,4BFDqB;EEErB,kBAAkB;EAClB,eAAe;EACf,oBAAoB,EAAA","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Gaegu:wght@400;700&display=swap\");\n\nbody {\n  font-family: \"Gaegu\", cursive;\n}\n\n:root {\n  font-size: 20px;\n}\n\na {\n  text-decoration: none;\n  color: $primaryBlue;\n}\n\n@mixin color-modifiers {\n  @each $name, $hex in $teamColors {\n    &-#{$name} {\n      color: $hex;\n    }\n  }\n}\n\n.text {\n  @include color-modifiers();\n}\n","$background: #f9e5a9;\n$primaryGrey: gainsboro;\n$primaryBlue: rgb(0, 149, 255);\n$primaryRed: rgb(255, 0, 0);\n$primaryYellow: rgb(255, 212, 0);\n$primaryGreen: rgb(0, 177, 6);\n\n$teamColors: (\n  \"red\": $primaryRed,\n  \"blue\": $primaryBlue,\n  \"green\": $primaryGreen,\n);\n\n$cardColors: map-merge(\n  $teamColors,\n  (\n    \"neutral\": $primaryYellow,\n    \"black\": #000,\n  )\n);\n\n$spyCardCellColors: map-merge(\n  $teamColors,\n  (\n    \"black\": #292929,\n  )\n);\n","@import \"./../style/colors\";\n\n$buttonColors: (\n  \"blue\": $primaryBlue,\n  \"green\": $primaryGreen,\n);\n\n@mixin colored-buttons {\n  @each $name, $hex in $buttonColors {\n    $lightened: rgba($hex, 0.8);\n    &.#{$name} {\n      border-color: $lightened;\n\n      &:hover {\n        background-color: $lightened;\n        border-color: $hex;\n      }\n    }\n  }\n}\n\n.btn {\n  border-radius: 6px;\n  border: 2px solid #000;\n  color: initial;\n  cursor: pointer;\n  display: block;\n  font-size: 1rem;\n  font-weight: 500;\n  margin-top: 1rem;\n  padding: 0.5rem 1rem;\n  text-decoration: none;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  font-family: inherit;\n  @include colored-buttons();\n\n  &:hover {\n    background-color: rgba($primaryGreen, 0.8);\n    border-color: $primaryGreen;\n    color: white;\n  }\n}\n\nbutton.no-style,\nbutton.link {\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  font-size: inherit;\n  font-family: inherit;\n  cursor: pointer;\n}\n\nbutton.link {\n  color: $primaryBlue;\n  padding-left: 0.2rem;\n}\n\nbutton.link:hover {\n  text-decoration: underline;\n}\n","input {\n  padding: 0.5rem 1rem;\n  border: 2px dashed $primaryGrey;\n  border-radius: 4px;\n  font-size: 1rem;\n  font-family: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
